import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'smartRound' })
export class SmartRoundPipe implements PipeTransform {
  transform(value: number | undefined, addPadding: boolean = false): string | undefined {
    if (value === undefined || isNaN(value)) {
      return;
    }

    const origDecimals: number = (value.toString().split('.')[1] || '').length;

    let decimals: number;
    if (origDecimals <= 2) {
      decimals = 2;
    } else {
      decimals = value < 10 ? 4 : 2;
    }

    const factor: number = Math.pow(10, decimals);
    const rounded: number = Math.ceil(parseFloat((value * factor).toFixed(decimals + 2))) / factor;
    const formatted = rounded.toFixed(decimals).replace('.', ',');
    return decimals === 2 && addPadding ? formatted + '\u2007\u2007' : formatted;
  }
}
